import React from 'react';
import Button from 'shared/components/button/Button';
import 'features/auth/components/password/forgetPassword.scss';
import Loader from 'features/Loader/Loader';

const VerificationEmailIsSent = props => {

  let { loading, unverifiedEmail } = props;

  if(loading) {
    return <Loader />;
  }
  return (
    <div className="onboarding">
      <div className="reset-password">
        <div className="form-side">
          <div className="shape shape-left"></div>
          <div className="shape shape-right"></div>
          <div className="form-content">
            <h3>Verify your email</h3>
            <p className="verify-hint">
              { unverifiedEmail ? 'Please ': 'Thank you for joining Hybrid trainers, ' }
              to finish the registration, we just need you to check your mail to verify
              your account
            </p>
            <div className="resend-hint">
              <p>
                Didn’t recieve the email?{' '}
                <Button
                  type="submit"
                  color="link"
                  customClasses="resend-btn"
                  label='Resend'
                  onClick={event => props.resendVerification()}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationEmailIsSent;
